import { money } from "../lib/budgetTime";

const when = (iso) => {
  try {
    return new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
  } catch {
    return iso;
  }
};

const Tag = ({ children, testid }) => (
  <span data-testid={testid} className="rounded-full bg-muted px-2 py-0.5 font-mono2 text-[10px] uppercase tracking-widest">{children}</span>
);

// The last 10 changes of today's budget (any day), newest first, as written to the audit log.
export const BudgetChangesList = ({ changes }) => (
  <div className="mt-4">
    <p className="text-xs uppercase tracking-widest text-muted-foreground font-mono2">Last 10 changes</p>
    {(changes || []).length ? (
      <ul data-testid="today-budget-changes" className="mt-2 space-y-1.5">
        {changes.slice(0, 10).map((c, i) => (
          <li key={`${c.at}-${i}`} data-testid={`today-budget-change-${i}`} className="flex flex-wrap items-center gap-2 rounded-xl border border-border bg-background px-3 py-2 text-xs">
            <span className="font-mono2 font-semibold">{money(c.meta?.from_usd)} → {money(c.meta?.to_usd)}</span>
            <span className="text-muted-foreground">{when(c.at)} · {c.meta?.by_email || c.staff_id}</span>
            {c.meta?.above_cap && <Tag testid={`today-budget-change-above-cap-${i}`}>above cap</Tag>}
            {c.meta?.reopened && <Tag testid={`today-budget-change-reopened-${i}`}>re-opened</Tag>}
            {!c.meta?.emailed && <Tag testid={`today-budget-change-no-email-${i}`}>email not sent</Tag>}
          </li>
        ))}
      </ul>
    ) : (
      <p data-testid="today-budget-changes-empty" className="text-sm text-muted-foreground mt-1">No changes yet.</p>
    )}
  </div>
);
